<script>
import { GlIcon, GlLink, GlPopover } from '@gitlab/ui';

const H6_CLASS = 'gl-inline gl-font-normal gl-text-sm gl-text-gray-900';

export default {
  name: 'GroupDetails',
  components: {
    GlIcon,
    GlLink,
    GlPopover,
  },
  props: {
    namespace: {
      type: String,
      required: false,
      default: null,
    },
    namespaceDetails: {
      type: Object,
      required: false,
      default: null,
    },
    subscriptionName: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    shortUrl() {
      if (!this.namespaceDetails?.webUrl) {
        return '';
      }

      return this.namespaceDetails.webUrl.replace(/^https?:\/\//, '');
    },
    shouldShowGroupUrl() {
      return this.namespaceDetails?.webUrl && this.namespace;
    },
    shouldShowGroupId() {
      return this.namespaceDetails?.id && this.namespace;
    },
    popoverTargetId() {
      return `group-link-${this.subscriptionName || this.namespaceDetails?.id}`;
    },
  },
  H6_CLASS,
};
</script>

<template>
  <section>
    <template v-if="shouldShowGroupUrl">
      <h5
        v-if="shouldShowGroupUrl"
        class="gl-font-normal gl-text-gray-600"
        data-testid="gitlab-group-title"
      >
        GitLab group:
        <gl-link
          :id="popoverTargetId"
          target="_blank"
          :href="namespaceDetails.webUrl"
          data-testid="gitlab-group-link"
          class="gl-inline-flex gl-items-center gl-gap-2"
        >
          {{ namespace }}
          <gl-icon name="external-link" />
        </gl-link>
      </h5>
      <gl-popover :target="popoverTargetId" :title="namespace" triggers="hover focus">
        <div>
          <h6 :class="$options.H6_CLASS">Group ID:</h6>
          <span data-testid="group-id"> {{ namespaceDetails.id }} </span>
        </div>

        <div>
          <h6 :class="$options.H6_CLASS" data-testid="popover-url-title">URL:</h6>
          <gl-link
            :href="namespaceDetails.webUrl"
            class="gl-text-sm"
            target="_blank"
            data-testid="popover-url"
            >{{ shortUrl }}</gl-link
          >
        </div>
      </gl-popover>
    </template>
    <h5 v-else-if="shouldShowGroupId" class="gl-font-normal gl-text-gray-600">
      GitLab group: {{ namespace }}
    </h5>
    <h5 v-else class="gl-font-normal gl-text-gray-600">GitLab group: Not assigned</h5>
  </section>
</template>
